<template>
  <q-modal v-model="visible" content-css="width: 800px;" content-classes="q-pa-lg">
    <h2>Настройка способов оплаты</h2>
    <q-select
      v-model="paymentMethod"
      stack-label="Способ оплаты"
      :options="paymentMethodsOptions"
      color="secondary"
      inverted
    />
    <component
      v-if="paymentMethod"
      :is="currentMethodComponent"
      :details="currentMethodDetails"
      @close="visible = false"
    />
  </q-modal>
</template>

<script>
  import {
    QModal,
    QSelect
  } from 'quasar';

  import {
    InvoiceMethod,
    WayforpayMethod
  } from './methods';

  const PAYMENTS_LIST = [
    {
      label: 'Счет-фактура',
      value: 'invoice'
    },
    {
      label: 'Wayforpay',
      value: 'wayforpay'
    }
  ];

  export default {
    name: 'PaymentMethodEdit',
    components: {
      QModal,
      QSelect,
      InvoiceMethod,
      WayforpayMethod
    },
    props: {
      value: Boolean,
      paymentDetails: Array
    },
    computed: {
      visible: {
        get () {
          return this.value;
        },
        set (val) {
          this.$emit('input', val);
        }
      },
      paymentDetailsMethods () {
        return this.paymentDetails.map(item => item.payment_method);
      },
      paymentMethodsOptions () {
        return PAYMENTS_LIST.filter(item => this.paymentDetailsMethods.includes(item.value));
      },
      currentMethodComponent () {
        return this.paymentMethod + 'Method';
      },
      currentMethodDetails () {
        return this.paymentDetails.find(item => item.payment_method === this.paymentMethod);
      },
    },
    data () {
      return {
        paymentMethod: null
      };
    },
    watch: {
      paymentDetails () {
        this.paymentMethod = this.getFirstPaymentMethod();
      }
    },
    methods: {
      getFirstPaymentMethod() {
        return this.paymentDetails.length ? this.paymentDetails[0].payment_method : null
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ServiceProviderSetting/PaymentMethodEdit.vue